const Toast = {
  SHORT: 0,
  LONG: 1,
  show: () => {},
  showWithGravity: () => {},
  showWithGravityAndOffset: () => {}
};

export default Toast;
